// src/api/capabilities.js
// Tier and capability system API helpers

import axios from "axios";
import {
  clearEntitlementToken,
  ensureEntitlementAxiosInterceptor,
  setEntitlementToken,
} from "./entitlement";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

ensureEntitlementAxiosInterceptor();

export const getCapabilities = async () => {
  const response = await axios.get(`${API_BASE_URL}/capabilities`);
  return response.data;
};

export const validateLicenseAndStoreEntitlement = async (payload = {}) => {
  const response = await axios.post(`${API_BASE_URL}/auth/validate-license`, payload);
  const data = response.data || {};
  const token = String(data.entitlement_token || "").trim();
  if (token) {
    setEntitlementToken(token);
  }
  return data;
};

export const getEntitlementStoreStatus = async () => {
  const response = await axios.get(`${API_BASE_URL}/auth/entitlement-store-status`);
  return response.data;
};

export const clearStoredEntitlement = async () => {
  try {
    await axios.post(`${API_BASE_URL}/auth/clear-entitlement`, {});
  } catch {
    // Keep local clear behavior even if desktop secure-store clear fails.
  }
  clearEntitlementToken();
};

/**
 * Helper to check if a specific capability is enabled for the active tier.
 * @param {Object} capabilities - The capabilities dict from /capabilities response
 * @param {String} capabilityName - The capability flag name (e.g., "compare_export_profiles")
 * @returns {Boolean} Whether the capability is enabled
 */
export const hasCapability = (capabilities, capabilityName) => {
  return Boolean(capabilities?.[capabilityName]);
};

/**
 * Helper to check if the active tier is at least a certain level.
 * Useful for feature gates that apply to multiple tiers.
 * @param {String} activeTier - The active tier name (e.g., "pro")
 * @param {Array<String>} includeTiers - Tiers that have access (e.g., ["pro", "executive"])
 * @returns {Boolean} Whether the active tier is in the allowed list
 */
export const isTierAllowed = (activeTier, includeTiers = []) => {
  return includeTiers.includes(activeTier);
};
